import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots } from "vue"

import Popup from './popup.vue';

interface Props {
  title?: string;
  modelValue: boolean;
  clickOverlayCancel?: boolean;
  showClose?: boolean;
}

interface Emits {
  (event: 'update:model-value', val: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    modelValue: { type: Boolean },
    clickOverlayCancel: { type: Boolean },
    showClose: { type: Boolean }
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:model-value', val: boolean): void;
}), expose: any, slots: any, attrs: any }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "model-value": __props.modelValue,
    title: __props.title,
    class: "modal-error",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = val => emits('update:model-value', val))
  }, _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (slot, slotName) => {
      return {
        name: slotName,
        fn: _withCtx((scope) => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(slot), _normalizeProps(_guardReactiveProps(scope)), null, 16))
        ])
      }
    })
  ]), 1032, ["model-value", "title"]))
}
}

})